module.exports = __webpack_public_path__ + "img/face-sad-sweat.f40978c1.svg";